import { configuration } from '../../../app/common-reducers.js';
import { setOptions } from '../../../features/facets/automatic-facet-set/automatic-facet-set-actions.js';
import { automaticFacetSetReducer as automaticFacetSet } from '../../../features/facets/automatic-facet-set/automatic-facet-set-slice.js';
import { searchReducer as search } from '../../../features/search/search-slice.js';
import { loadReducerError } from '../../../utils/errors.js';
import { buildController, } from '../../controller/headless-controller.js';
import { buildAutomaticFacet } from '../automatic-facet/headless-automatic-facet.js';
import { buildOptions, } from './headless-automatic-facet-generator-options.js';
/**
 * Creates a `AutomaticFacetGenerator` instance.
 *
 * @param engine - The headless engine.
 * @param props - The automatic facets props.
 * @returns A `AutomaticFacetGenerator` controller instance.
 *
 * @group Controllers
 * @category AutomaticFacetGenerator
 */
export function buildAutomaticFacetGenerator(engine, props) {
    if (!loadAutomaticFacetGeneratorReducers(engine)) {
        throw loadReducerError;
    }
    const { dispatch } = engine;
    const options = buildOptions(props.options);
    dispatch(setOptions(options));
    const controller = buildController(engine);
    return {
        ...controller,
        get state() {
            const automaticFacets = engine.state.search.response.generateAutomaticFacets?.facets.map((facet) => buildAutomaticFacet(engine, { field: facet.field })) ?? [];
            return {
                automaticFacets,
            };
        },
    };
}
function loadAutomaticFacetGeneratorReducers(engine) {
    engine.addReducers({ automaticFacetSet, configuration, search });
    return true;
}
